export default __webpack_public_path__ + "static/media/A0005.0984059b.png";